<nav class="navbar console_topbar">
    <section class="menu_nav">
        <button class="navbar-toggler sidemenu_switch" type="button" (click)="toggleMenu(stretchMenu)">
            <i class="fas fa-bars" aria-hidden="true"></i>
        </button>
        <a href="#" [routerLink]="['']" class="navbar-brand brand_logo"></a>
    </section>

    <section class="user_nav">

        <button id="chatButton" type="button" class="btn chat_switch" (click)="toggleChat(openChat)"><i class="far fa-comment" aria-hidden="true"></i></button>
        <form class="journey_form" [spinnerLoader]="subscriptions['Journey']?.closed" [size]="'sm'">
            <div ngbDropdown>
                <button type="button" class="form-select custom_select_dropdown journey_dropodown" id="dropdownSeverities" ngbDropdownToggle>{{ activeJourney?.name }}</button>
                <div ngbDropdownMenu aria-labelledby="dropdownSeverities">
                    <button ngbDropdownItem [ngClass]="{ active: item.id === activeJourney?.id }" *ngFor="let item of journeys" (click)="switchJourney(item)">
                        {{ item.name }}
                    </button>
                </div>
            </div>
        </form>
        <button class="btn profile_switch" [ngbPopover]="popUser" [autoClose]="'outside'" [placement]="'bottom-right'" [popoverClass]="'pop_user'">
            <span class="user_name">{{ user?.firstName }} {{ user?.lastName }}</span>
            <i class="fas fa-user user_avatar" aria-hidden="true"></i>
        </button>
    </section>
</nav>

<ng-template #popUser>
    <article class="account_info">
        <header class="info_head">
            <figure class="head_image">
                <i class="fas fa-user-circle fa-6x" aria-hidden="true"></i>
            </figure>
            <h5 class="head_title">{{ user?.firstName }} {{ user?.lastName }}</h5>
            <h6 class="head_subtitle">
                <small>{{ user?.email }}</small>
            </h6>
            <ul class="list-unstyled account_action">
                <li>
                    <button type="button" class="btn" (click)="modalSettings()"><i class="material-icons" aria-hidden="true">settings</i></button>
                </li>
                <li>
                    <button type="button" class="btn" (click)="logout()"><i class="material-icons" aria-hidden="true">power_settings_new</i></button>
                </li>
            </ul>
        </header>
        <div class="info_body" [spinnerLoader]="subscriptions['SetAccount']?.closed">
            <ul class="list-unstyled account_list">
                <li *ngFor="let account of userAccounts" [ngClass]="{ active: user?.accountId === account.id }">
                    <a href="javascript:void(0)" (click)="switchAccount(account)">{{ account.name }}</a>
                </li>
            </ul>
        </div>
    </article>
</ng-template>

